import { gql } from "@apollo/client"
import { PaymentsSettings } from "@oysterhr/schema"
import { useQuery, UseQueryOptions } from "@oysterhr/core"

export const GET_COMPANY_PAYMENTS_SETTINGS = gql`
  query CompanyPaymentMandateSetup($companyId: ID!) {
    company(companyId: $companyId) {
      id
      paymentsSettings {
        paymentsMandateSetup
        contractorDdEnabled
      }
    }
  }
`
type Result = {
  company: {
    paymentsSettings: {
      paymentsMandateSetup: PaymentsSettings["paymentsMandateSetup"]
      contractorDdEnabled: PaymentsSettings["contractorDdEnabled"]
    }
  }
}

type Variables = {
  companyId: string
}

export const useCompanyPaymentsSettings = (options: UseQueryOptions<Result, Variables>) =>
  useQuery<Result, Variables>(GET_COMPANY_PAYMENTS_SETTINGS, options)
